export default __webpack_public_path__ + "static/media/umida.2ab1199f.jpg";